<template>
  <div>
    <b-form-textarea
      :state="answer.valid"
      :disabled="loading"
      class="input-question mt-3"
      v-model="answer.val"
      placeholder="Escribe tu respuesta..."
      rows="3"
      max-rows="6"
    ></b-form-textarea>
    <b-button
      @click="sendAnswer"
      style="float:right"
      :disabled="loading"
      class="mt-3 ml-4 btn-sm b-yellow"
    >
      <b-spinner v-if="loading" small></b-spinner>
      <i v-if="!loading" class="fas fa-save"></i> Guardar
    </b-button>
    <b-button @click="cancel" style="float:right" :disabled="loading" class="mt-3 btn-sm b-light">
      <i class="fas fa-arrow-left"></i> Volver
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
      answerOld:Object
  },
  data() {
    return {
        loading:false,
      answer: {
        valid: null,
        val: ""
      }
    };
  },
  created() {
    this.answer.val = this.answerOld.answer;
  },
  methods:{
      cancel(){
          this.bus.$emit("CancelEditAnswer", this.answerOld.id);
      },
      verifyInputs() {
      let answer = this.answer.val.trim()

      if (answer != "" && answer != null && answer != undefined) {
        this.answer.valid = true;
      } else {
        this.answer.valid = false;
      }

    },
      sendAnswer(){
     this.loading = true;
      this.verifyInputs();
      if (this.answer.valid) {
        let url =
          "course/" +
          this.$parent.question.curse_id +
          "/question/" +
          this.$parent.question.id + 
          "/answer/"+
          this.answerOld.id;
        
        this.api
          .put(url, {
            data: {
              answer: this.answer.val,
            }
          })
          .then(({ data }) => {
            this.loading = false;
            if (data.updating) {
              this.bus.$emit("UpdateAnswer", {
                answer: this.answer.val,
                answer_id: this.answerOld.id
              });
              this.bus.$emit("UpdateQuestions", data.data_return);
              this.answer = {
                val: "",
                valid: null
              };
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        this.loading = false;
      }
      }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/EditAnswer.vue